"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs/add/operator/toPromise");
var Observable_1 = require("rxjs/Observable");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var core_1 = require("@angular/core");
var form_model_1 = require("../model/form.model");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/zip");
var http_1 = require("@angular/common/http");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
/**
 *
 * @author Anania.Mikaelyan
 */
var FormManagementHttpService = /** @class */ (function () {
    function FormManagementHttpService(http, applicationPropertiesService, currentLanguageProvider, languageService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
        this.URL_FORMS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/forms"], ["", "/forms"])), "serviceUri");
        this.URL_FORMS_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/", "/forms"], ["", "/", "/forms"])), "serviceUri", "prefix");
        this.URL_FORM = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/forms/", ""], ["", "/forms/", ""])), "serviceUri", "formId");
        this.URL_ADD_UPDATE_FORM = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/forms"], ["", "/forms"])), "serviceUri");
        this.URL_ADD_UPDATE_FORM_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/", "/forms"], ["", "/", "/forms"])), "serviceUri", "prefix");
        this.URL_REMOVE_FORM = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/forms/", ""], ["", "/forms/", ""])), "serviceUri", "formId");
        this.FORM_MANAGEMENT_URL_KEY = "form-service-url";
        this.formManagementServiceUrlKey$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.FORM_MANAGEMENT_URL_KEY));
        this.language$ = this.currentLanguageProvider.getCurrentLanguage();
        this.languages$ = this.languageService.getAvailableLanguages();
    }
    FormManagementHttpService.prototype.loadAll = function (prefix) {
        var _this = this;
        var data$ = this.formManagementServiceUrlKey$
            .flatMap(function (formManagementServiceUrl) {
            var url = _this.getUrlForGettingData(formManagementServiceUrl, prefix);
            return _this.http.get(url);
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return _this.deserializeServerResponse(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.loadFormsBySystemName = function (systemName, prefix) {
        var _this = this;
        var data$ = this.formManagementServiceUrlKey$
            .flatMap(function (formManagementServiceUrl) {
            var url = _this.getUrlForGettingData(formManagementServiceUrl, prefix);
            var params = new http_1.HttpParams()
                .set('formSystemName', systemName);
            return _this.http.get(url, { params: params });
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return _this.deserializeServerResponse(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.loadFormsByCategoryAndType = function (categorySystemName, type, prefix) {
        var _this = this;
        var data$ = this.formManagementServiceUrlKey$
            .flatMap(function (formManagementServiceUrl) {
            var url = _this.getUrlForGettingData(formManagementServiceUrl, prefix);
            var params = new http_1.HttpParams()
                .set('categorySystemName', categorySystemName)
                .set('typeId', type.toString());
            return _this.http.get(url, { params: params });
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return _this.deserializeServerResponse(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.loadForm = function (formId) {
        var _this = this;
        var data$ = this.formManagementServiceUrlKey$
            .flatMap(function (formManagementServiceUrl) {
            var url = _this.URL_FORM.replaceTemplate({
                "serviceUri": formManagementServiceUrl,
                "formId": formId.toString()
            });
            return _this.http.get(url);
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return _this.deserializeForm(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.create = function (form, prefix) {
        var _this = this;
        var url$ = this.formManagementServiceUrlKey$
            .map(function (formManagementServiceUrl) {
            return _this.getUrlForAddUpdate(formManagementServiceUrl, prefix);
        });
        var data$ = Observable_1.Observable.zip(url$, this.languages$).flatMap(function (data) {
            return _this.http.post(data[0], _this.serializeForm(form, data[1]));
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return _this.deserializeForm(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.update = function (form, prefix) {
        var _this = this;
        var url$ = this.formManagementServiceUrlKey$
            .map(function (formManagementServiceUrl) {
            return _this.getUrlForAddUpdate(formManagementServiceUrl, prefix);
        });
        var data$ = Observable_1.Observable.zip(url$, this.languages$).flatMap(function (data) {
            return _this.http.put(data[0], _this.serializeForm(form, data[1]));
        });
        return Observable_1.Observable.zip(data$, this.languages$).map(function (data) {
            return _this.deserializeForm(data[0], data[1]);
        });
    };
    FormManagementHttpService.prototype.delete = function (form) {
        var _this = this;
        var url$ = this.formManagementServiceUrlKey$
            .map(function (formManagementServiceUrl) {
            return _this.URL_REMOVE_FORM.replaceTemplate({
                "serviceUri": formManagementServiceUrl,
                "formId": form.id.toString()
            });
        });
        return url$.flatMap(function (url) {
            return _this.http.delete(url);
        });
    };
    FormManagementHttpService.prototype.deserializeServerResponse = function (data, languages) {
        var _this = this;
        var items = [];
        var jsonData = data.json ? data.json() : data; //done for loading json from file as well
        jsonData.forEach(function (jsonItem) {
            items.push(_this.deserializeForm(jsonItem, languages));
        });
        return items;
    };
    FormManagementHttpService.prototype.deserializeForm = function (jsonItem, languages) {
        return new form_model_1.Form(jsonItem.id, jsonItem.formSystemName, jsonItem.categorySystemName, jsonItem.typeId, idm_de_core_frontend_1.deserializeMultilingualString(jsonItem.name, languages), idm_de_core_frontend_1.deserializeMultilingualString(jsonItem.description, languages), jsonItem.data, jsonItem.subCategorySystemName, jsonItem.formEntityTypeId);
    };
    FormManagementHttpService.prototype.serializeForm = function (form, languages) {
        var formData = {};
        formData['id'] = form.id;
        formData['categorySystemName'] = form.categorySystemName;
        formData['formSystemName'] = form.systemName;
        formData['name'] = idm_de_core_frontend_1.serializeMultilingualString(form.name, languages);
        formData['description'] = idm_de_core_frontend_1.serializeMultilingualString(form.description, languages);
        formData['typeId'] = form.typeId;
        formData['subCategorySystemName'] = form.subCategorySystemName;
        formData['formEntityTypeId'] = form.entityTypeId;
        formData['data'] = '';
        return formData;
    };
    FormManagementHttpService.prototype.getUrlForGettingData = function (formManagementServiceUrl, prefix) {
        return !prefix ? this.URL_FORMS.replaceTemplate({ "serviceUri": formManagementServiceUrl }) :
            this.URL_FORMS_WITH_PREFIX.replaceTemplate({ "serviceUri": formManagementServiceUrl, "prefix": prefix });
    };
    FormManagementHttpService.prototype.getUrlForAddUpdate = function (formManagementServiceUrl, prefix) {
        return !prefix ? this.URL_ADD_UPDATE_FORM.replaceTemplate({
            "serviceUri": formManagementServiceUrl,
        }) : this.URL_ADD_UPDATE_FORM_WITH_PREFIX.replaceTemplate({
            "serviceUri": formManagementServiceUrl,
            "prefix": prefix
        });
    };
    FormManagementHttpService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.LanguageService])
    ], FormManagementHttpService);
    return FormManagementHttpService;
}());
exports.FormManagementHttpService = FormManagementHttpService;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=form-management-http.service.js.map